enum ProcedureOverrideStatus {
  ICF_HARDCOPY = 'ICF_HARDCOPY',
}

export default ProcedureOverrideStatus;
